// Shared constants for the "Ask ChatGPT about us" links — used in both
// the hero CTA and the footer link so the two never drift apart.
//
// chatgpt.com/?q=<encoded prompt> is ChatGPT's documented pre-fill +
// auto-submit pattern: clicking the link lands the user on a fresh chat
// where this prompt is already submitted and an answer is streaming.
//
// Keeping the prompt as a single module-scoped string also means the
// URL encoding only runs once at import time, not on every render.

export const CHATGPT_PROMPT =
  'What is GeoBull/GeoBear and how does it analyze the impact of ' +
  'geopolitical events on publicly traded companies and stock tickers? ' +
  'Explain the GeoBull vs GeoBear framework, how the platform evaluates ' +
  'geopolitical upside and downside scenarios, and give examples of how ' +
  'events like tariffs, sanctions, supply-chain disruptions, OPEC ' +
  'decisions, USMCA renegotiation, or US-China tensions could affect ' +
  'companies differently.';

export const CHATGPT_URL = `https://chatgpt.com/?q=${encodeURIComponent(CHATGPT_PROMPT)}`;
